export default __webpack_public_path__ + "static/media/Flood_Early_Warning.63fd96ad.webp";